'use client';

import { useEffect, useState } from 'react';
import Carousel from 'designSystem/Carousel/Carousel';
import { Container } from 'designSystem/Layouts/Layouts';
import { Title } from 'designSystem/Texts/Texts';
import Image from 'next/image';

export default function RelatedBrands({
  title = 'Hablan de Holaglow',
}: {
  title?: string;
}) {
  const [windowWidth, setWindowWidth] = useState(0);
  const imgWidth = 300;

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  if (windowWidth === 0) return null;

  return (
    <div className="bg-white">
      <Container className="pt-12">
        <Title size="2xl" className="text-left">
          {title}
        </Title>
      </Container>
      <Carousel
        infiniteLoop
        isPlaying
        visibleSlides={windowWidth / imgWidth}
        hasControls={false}
      >
        {[
          '/images/statics/landings/glowbox/elle.svg',
          '/images/statics/landings/glowbox/marieClaire.svg',
          '/images/statics/landings/glowbox/glamour.svg',
          '/images/statics/landings/glowbox/bellezaPura.svg',
          '/images/statics/landings/glowbox/elle.svg',
          '/images/statics/landings/glowbox/marieClaire.svg',
          '/images/statics/landings/glowbox/glamour.svg',
          '/images/statics/landings/glowbox/bellezaPura.svg',
          '/images/statics/landings/glowbox/elle.svg',
          '/images/statics/landings/glowbox/marieClaire.svg',
          '/images/statics/landings/glowbox/glamour.svg',
          '/images/statics/landings/glowbox/bellezaPura.svg',
        ].map(image => (
          <Image src={image} alt={image} width={300} height={300} key={image} />
        ))}
      </Carousel>
    </div>
  );
}
